import React from "react";
import { Link } from "react-router-dom";

function HowWillThisHelpYou() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-how-will-this-help-you">
      <div data-aos="fade-right" className="container d-flex flex-column align-items-start justify-content-start vh-100 w-100">
            <div className="row d-flex justify-content-center align-items-start my-auto text-center w-35">
                <div className="bg-white rounded-border py-3 border border-4 border-dark">
                    <div className="col-12 heading-font mb-3">
                        <div type="button" className="btn btn-warning rounded-pill w-100 py-3 fs-4">How Will This Help You</div>
                    </div>
                    <p>Many people spend a lifetime making financial decisions based on assumptions they believe to be true…</p>
                    <p>…only to find out decades later that their decisions were based on flawed ideas.</p>
                    <p>This can result in a lifetime of stress, sleepless nights and a waste of precious time and money.</p>
                    <p>This simulation was designed to enable you to experience, in an interactive way, how to avoid these same pitfalls.</p>

                    <Link to={'/enjoy-the-ride'} className="threeDButton btn fw-bold  w-75">Let’s Dive In!</Link>
                </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default HowWillThisHelpYou;
